export default __webpack_public_path__ + "static/media/Deezer.2dd4de1f.svg";